import Constants from 'expo-constants';
import { useEffect } from 'react';

import { useUserAccountsQuery } from '@fhs-legacy/frontend/src/generated/rbi-graphql';
import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';
import { ISOs } from '@fhs-legacy/frontend/src/utils/form/constants';

import { usePaymentMethodStore } from '../../../../payment';

import { useApplePayAvailability, useGooglePayAvailability } from './digital-wallet-availability';

export default function useAvailablePaymentMethods() {
  const setUserAccountsData = usePaymentMethodStore(s => s.setUserAccountsData);
  const currentUserAccountsData = usePaymentMethodStore(s => s.userAccountsData);

  const canUseGiftCards = useFlag(LaunchDarklyFlag.ENABLE_GIFT_CARD);
  const canUseApplePay = useApplePayAvailability();
  const canUseGooglePay = useGooglePayAvailability();

  const feAlpha3CountryCode = Constants.expoConfig?.extra?.eas.buildRegion === 'US' ? 'USA' : 'CAN';

  // uses cache from apollo to obtain the userAccounts data again, if not loads with skeleton
  const { data: userAccountsData, loading: userAccountsLoading } = useUserAccountsQuery({
    variables: { feCountryCode: feAlpha3CountryCode as ISOs },
    fetchPolicy: 'cache-and-network',
    skip: (currentUserAccountsData?.userAccounts?.accounts?.length ?? 0) > 0,
  });

  useEffect(() => {
    if (!userAccountsData) return;

    if (userAccountsData !== currentUserAccountsData) {
      setUserAccountsData(userAccountsData);
    }
  }, [userAccountsData, currentUserAccountsData, setUserAccountsData]);

  return {
    canUseGiftCards,
    canUseApplePay,
    canUseGooglePay,
    userAccountsLoading,
  };
}
